import React from 'react';
import { HuchaRenovadoresCardC1 } from './hucha-renovadores-card-c1';
import { HuchaRenovadoresCardC2 } from './hucha-renovadores-card-c2';
import { HuchaRenovadoresCardC3 } from './hucha-renovadores-card-c3';
import { HuchaValues } from '../../../models/hucha-values';
import { RenovadoresHuchaCardContainer } from '../../ui/hucha-card-container';

const HuchaRenovadoresCard: React.FC<{
	huchaValues: HuchaValues | null;
}> = ({ huchaValues }): React.ReactElement => {
	return (
		<RenovadoresHuchaCardContainer>
			<HuchaRenovadoresCardC1 huchaValues={huchaValues} />
			<HuchaRenovadoresCardC2 dineroHucha={huchaValues?.dineroHucha || '0'} />
			<HuchaRenovadoresCardC3 huchaValues={huchaValues} />
		</RenovadoresHuchaCardContainer>
	);
};

export default HuchaRenovadoresCard;
